module.exports = __webpack_public_path__ + "static/Lakshman Ventakaswami-f0d7b4e64bf3e58efdc3b3f4cc5fae03.jpg";